export const OPEN_BOTTOM_TOGGLE = 'OPEN_BOTTOM_TOGGLE';
export const CLOSE_BOTTOM_TOGGLE = 'CLOSE_BOTTOM_TOGGLE';